import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { deleteSharedAccountLookalikeAudience } from '../../sources/sharedAccounts';
import { removeSharedAccount } from '../queryKeyFactory';

export const useDeleteSharedAccount = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const deleteMutation = useMutation(
    removeSharedAccount(),
    deleteSharedAccountLookalikeAudience,
    {
      successMessage: () => `Shared account removed`,
    }
  );

  const handleAction = async ({ id, lookalikeAudience, name }) => {
    await showModal({
      title: `Remove shared account?`,
      confirmActionLabel: 'Remove',
      bodyText: `${name}`,
    });

    await deleteMutation.mutateAsync({ id, lookalikeAudience });
  };

  return [handleAction, deleteMutation];
};
